<template>
    <div class="zdmain">
        <div class="contentbox">
            <div class="contentitem" v-for="item in list" :key="item">
                <!-- <div class="times">{{item.time}}S</div> -->
                 <div class="statustip" v-if="item.ctlstatus"><div class="point"></div>远程控制中</div>
                 <div class="statustip st2" v-else><div class="point p2"></div>本地控制中</div>
                <div class="itemicon">
                    <img :src="item.icon" />
                </div>
                <div class="title">{{item.title}}</div>
                <div class="turnbox">
                    <div class="txt" v-if="item.status">
                        <div class="point"></div>
                        <div class="statustxt">AI监控中</div>
                    </div>
                    <div class="txt t3" v-else-if="!item.ctlstatus">
                        <div class="point"></div>
                        <div class="statustxt">已离线</div>
                    </div>
                    <div class="txt t2" v-else>
                        <div class="point"></div>
                        <div class="statustxt st2">手动控制中</div>
                    </div>
                    <div class="toggle-container">
                        <el-switch
                            @change="statuschange(item)"
                            v-model="item.status"
                            :disabled="!item.ctlstatus"
                            active-color="#67C23A"
                            inactive-color="#f472b6">
                        </el-switch>
                    </div>
                    <!-- <div class="toggle-container" v-if="item.ctlstatus">
                        <label class="switch">
                            <input type="checkbox" :checked="item.status" @change="statuschange(item)">
                            <span class="slider"></span>
                        </label>
                    </div> -->
                </div>
            </div>
            <div class="setbtnbox">
                <div class="setbtn" @click="sbdrawer = true"><i class="el-icon-setting"></i></div>
                <div class="msgbtn" @click="openhislist"><img src="../../assets/img/znt/icon.png" /></div>
            </div>
        </div>

        <el-drawer
            title="AI智控记录"
            :visible.sync="drawer"
            direction="btt"
            size="50%"
            :before-close="handleClose">
            <div class="infoitem" v-for="(item, i) in tabledata">
                <div class="time">
                    <div v-if="i == 0" class="point"></div>
                    {{item.updateTime}}
                </div>
                <div class="content">{{item.content}}</div>
            </div>
        </el-drawer>
        <el-drawer
            title="可操控设备列表"
            :visible.sync="sbdrawer"
            direction="btt"
            size="200px"
            :before-close="handleClose">
            <div class="sbitembox">
                滴灌电磁阀（{{sb1status == '1' ? '已开启' : '已关闭'}}）：
                <el-switch
                    v-model="sb1status"
                    active-color="#13ce66"
                    inactive-color="#f472b6"
                    active-value="1"
                    inactive-value="2">
                </el-switch>
            </div>
            <div class="sbitembox">
                喷灌电磁阀（{{sb1status == '2' ? '已开启' : '已关闭'}}）：
                <el-switch
                    v-model="sb1status"
                    active-color="#13ce66"
                    inactive-color="#f472b6"
                    active-value="2"
                    inactive-value="1">
                </el-switch>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import {getwarlist, getsblist, setsbstatus, getsbonlinestatus} from '@/api/bot'
export default {
    name: 'index',
    components: {  },
    data() {
        return {
            drawer: false,
            sbdrawer: false,
            sb1status: '1',
            list: [{
                time: '480',
                icon: require('../../assets/img/znt/zngg.png'),
                status: true,
                ctlstatus: false,
                title: '智能灌溉'
            },{
                time: '150',
                icon: require('../../assets/img/znt/znhw.png'),
                status: true,
                ctlstatus: false,
                title: '智能控温'
            },{
                time: '120',
                icon: require('../../assets/img/znt/znbw.png'),
                status: true,
                ctlstatus: false,
                title: '智能保温'
            },{
                time: '120',
                icon: require('../../assets/img/znt/znfy.png'),
                status: true,
                ctlstatus: false,
                title: '智能防雨'
            }],
            reslistkey: {
                '1#2#卷膜机远程状态': '智能保温',
                '3#4#卷膜机远程状态': '智能防雨',
                '灌溉机远程状态': '智能灌溉',
                '遮阳帘远程状态': '智能控温'
            },

        }
    },
    computed: {

    },
    mounted() {
        this.getwarningdata()
        this.getlist()
    },
    methods: {
        getonlinelist() {
            getsbonlinestatus().then(res => {
                Object.keys(res).forEach(item => {
                    const newitem = this.list.filter(litem => this.reslistkey[item] == litem.title)[0]
                    console.log(newitem)
                    if (res[item] == 'False') {
                        newitem.status = false
                    }
                    newitem.ctlstatus = res[item] == 'True'
                })
            })
            
            console.log('设备是否在 线', this.list)
        },
        statuschange(item) {
            setTimeout(() => {
                setsbstatus(`id=${item.id}&status=${item.status}`).then(res => {
                    if (res.code == 200) {
                        
                        if (item.status) {
                        this.$message.success(`已开启${item.title}监控`)
                        } else {
                            this.$message.error(`已关闭${item.title}监控`)
                        }
                    } else {
                        
                        this.$message.error(res.message)
                    }
                    
                   
                })
            }, 200);
            
        },
        getlist() {
            getsblist().then(res => {
                console.log('设备列表', res)
                this.list.forEach(item => {
                    const newitem = res.data.filter(s => s.scene == item.title)[0]
                    console.log(newitem)
                    // item.time = newitem.time || 0;
                    item.status = newitem.status;
                    item.statusTime = newitem.statusTime;
                    item.id = newitem.id
                })
                setTimeout(() => {
                    this.getonlinelist()
                }, 500);
            })
        },
        openhislist() {
            this.drawer = true

        },
        handleClose() {
            this.drawer = false
            this.sbdrawer = false
        },
        getwarningdata() {
            getwarlist(`page=1&size=10`).then(res => {
                console.log('预警列表', res)
                this.tabledata = res.data.records
            })
        },
    }
}




</script>

<style scoped lang="less">
.zdmain {
    width: 100%;
    height: 100%;
    position: relative;
    padding: 20px 0;

    .contentbox{
        width: 100%;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        .contentitem{
            margin: 10px;
            width: calc(50% - 20px);
            background: rgba(255,255,255,0.6);
            border-radius: 10px;
            border: 1px solid #fff;
            padding: 10px;
            .statustip{
                width: 100%;
                justify-content: flex-end;
                display: flex;
                align-items: center;
                color: #45b26d;
                .point{
                    width: 10px;
                    height: 10px;
                    background-color: #45b26d;
                    border-radius: 50%;
                    margin-right: 10px;
                }
                .p2{
                    background-color: #545454;
                }
            }
            .st2{
                color: #545454;
            }
            .times{
                font-size: 22px;
                color: #D94E6B;
                text-align: center;
            }
            .itemicon{
                width: 100%;
                text-align: center;
                img{
                    width: 80px;
                }
            }
            .title{
                font-size: 16px;
                font-weight: bold;
                text-align: center;
                width: 100%;
                margin-bottom: 20px;
            }
            .turnbox{
                width: 100%;
                text-align: center;
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                justify-content: space-between;
                color: #00000080;
                font-size: 14px;

                .txt{
                    width: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-bottom: 5px;
                    color: #2b7c49;
                    .point{
                        width: 8px;
                        height: 8px;
                        margin-right: 10px;
                        border-radius: 50%;
                        background-color: #4ade80;
                    }
                }
                .t2{
                    color: #e0869a;
                    .point{
                        background-color: #e0869a;
                    }
                }
                .t3{
                    color: #545454;
                    .point{
                        background-color: #545454;
                    }
                }

                .toggle-container {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                
                .status-text {
                    font-size: 18px;
                    font-weight: bold;
                }
                
                .switch {
                    position: relative;
                    display: inline-block;
                    width: 50px;
                    height: 25px;
                
                }
                
                .switch input {
                    opacity: 0;
                    width: 0;
                    height: 0;
                }
                
                .slider {
                    position: absolute;
                    cursor: pointer;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background-color: #f472b6; /* 关闭状态颜色 */
                    transition: .3s;
                    border-radius: 34px;
                }
                
                .slider:before {
                    position: absolute;
                    content: "";
                    height: 18px;
                    width: 18px;
                    left: 4px;
                    bottom: 4px;
                    background-color: white;
                    transition: .3s;
                    border-radius: 50%;
                }
                
                input:checked + .slider {
                    background-color: #4ade80; /* 打开状态颜色 */
                }
                
                input:checked + .slider:before {
                    transform: translateX(23px);
                }
                
                #status {
                    padding: 12px;
                    border-radius: 8px;
                    color: white;
                    font-size: 18px;
                    font-weight: bold;
                    background-color: #f472b6; /* 关闭状态背景 */
                }
                
                input:checked ~ #status {
                    background-color: #4ade80; /* 打开状态背景 */
                }
                
                input:checked ~ .toggle-container .off {
                    color: #999; /* 打开时OFF文本变灰 */
                }
                
                input:checked ~ .toggle-container .on {
                    color: #4ade80; /* 打开时ON文本变绿 */
                }
                
                .off {
                    color: #f472b6; /* 关闭时OFF文本变粉 */
                }
                
                .on {
                    color: #999; /* 关闭时ON文本变灰 */
                }
            }
        }

        .setbtnbox{
            position: fixed;
            bottom: 20px;
            right: 20px;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            width: 40px;
            .setbtn{
                font-size: 30px;
                color: #00000090;
            }
            .msgbtn{
                margin-top: 20px;
                img{
                    width: 40px;
                }
            }
        }
    }

    /deep/ .el-drawer__header{
        font-size: 18px;
    }
    /deep/ .el-drawer__header{
        margin-bottom: 10px;
    }
    .infoitem{
        background-color: #1D280010;
        margin: 10px 20px;
        padding: 10px;
        border-radius: 8px;
        color: #00000080;
        .time{
            display: flex;
            align-content: center;
            .point{
                width: 10px;
                height: 10px;
                border-radius: 50%;
                background-color: #f3000082;
                margin-right: 10px;
            }
        }
        .content{
            font-size: 14px;
            margin-top: 10px;
            line-height: 20px;
        }
    }
    .sbitembox{
        background-color: #1D280010;
        margin: 10px 20px;
        padding: 10px;
        border-radius: 8px;
        color: #00000080;
        font-size: 14px;
    }
}

  
</style>
